export default "__VITE_ASSET__DavGIw_C__"